import { api } from "./api";
import { getToken, isLoggedIn } from "../services/AuthStorage";
import { getGuestId } from "../utils/guest";

export const addToWishlist = async (productId) => {
  const payload = { productId };

  if (!isLoggedIn()) {
    payload.guestId = getGuestId();
  }

  const headers = {};
  if (isLoggedIn()) {
    headers["Authorization"] = `Bearer ${getToken()}`;
  }

  const response = await api.post("/Favorite/add", payload, { headers });

  // ✅ Kiểm tra backend trả lỗi dạng nào
  if (
    response.status !== 200 ||
    (response.data && response.data.success === false)
  ) {
    throw new Error(response.data?.message || "Failed to add to wishlist");
  }

  return response.data;
};

export const getWishlistItems = async () => {
  try {
    const headers = {};
    let url = "/Favorite/list";

    if (isLoggedIn()) {
      headers["Authorization"] = `Bearer ${getToken()}`;
    } else {
      const guestId = getGuestId();
      url += `?guestId=${guestId}`;
    }

    const response = await api.get(url, { headers });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const removeFromWishlist = async (wishlistId) => {
  try {
    const headers = {};
    let url = `/Favorite/remove/${wishlistId}`;

    if (isLoggedIn()) {
      headers["Authorization"] = `Bearer ${getToken()}`;
    } else {
      const guestId = getGuestId();
      url += `?guestId=${guestId}`;
    }

    const response = await api.delete(url, { headers });
    return response.data;
  } catch (error) {
    throw error;
  }
};
